import React, { Component } from 'react'
import { Row } from 'react-bootstrap';
import '../css/TopMenu.css'

class TopMenu extends Component {

    render() {
        return (
            <React.Fragment>
                <Row>
                    <h1 className='header'>בחירות איזוריות בישראל</h1>
                </Row>
                <Row>
                    <h2 className='miniHeader'>מודל בן-זקן - בראון</h2>
                </Row>
                <Row>
                    <h3 className='subHeader'>
                        מודל בן-זקן -בראון לבחירות אזוריות מציג שתי חלוקות ל-120 מחוזות. החלוקה הראשונה מבוססת על הגבולות המוניציפליים הקיימים. החלוקה השניה מתבססת על צירוף קלפיות על בסיס קרבה גאוגרפית. המודל מבוסס על נתוני הקלפיות (כתובות ומספר בוחרים) בבחירות 2020.</h3>
                </Row>
            </React.Fragment>
        );
    }
}

export default TopMenu;